export enum DeviceOs {
  Android = "Android",
  iOS = "iOS",
}
